import React, { useState } from "react";
import { useStepper } from "../ui/stepper";

import { CompanionForm } from "../companionForm/CompanionForm";
import { CompanionFormStepItem } from "../companionForm/CompanionFormStepItem";
import { CompanionFormStep } from "../companionForm/CompanionFormStep";
import { LandingLpIntroHeader } from "./LandingLpFormIntroHeader";
import {
  GIRL_STYLES,

  // Landing Form Constants
  LP_FAKE_FORM_STEPS as STEPS,
  STYLES,
  NECTAR_URL,
} from "../../lib/constants";
import { getUrl } from "../../lib/utils";
import { SparklesIcon } from "lucide-react";

export const LandingLpForm = () => {
  const { currentStep } = useStepper();
  const [data, setData] = useState({
    style: null,
  });

  const handleChange = (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
  };

  const handleNext = () => {
    const style = data.style;
    if (!style) return;

    const basePath = NECTAR_URL + "/girls/create";

    if (style === STYLES.REALISM) {
      const path = `${basePath}?gender_preference=female`;
      window.location.href = getUrl(path);
    }

    if (style === STYLES.ANIME) {
      const path = `${basePath}?gender_preference=anime`;
      window.location.href = getUrl(path);
    }
  };

  return (
    <CompanionForm headerHeight={60}>
      {/* Header */}
      {currentStep === STEPS.STYLE && <LandingLpIntroHeader />}

      <CompanionFormStep id={STEPS.STYLE} next={handleNext}>
        <div className="flex items-center justify-center gap-2">
          <h2 className="text-xl lg:text-2xl font-bold text-center">
            Create My AI
          </h2>
          <SparklesIcon className="size-6 fill-foreground-500 stroke-foreground-500" />
        </div>

        <div className="grid grid-cols-2 gap-4 mt-6">
          {GIRL_STYLES.map((item) => (
            <CompanionFormStepItem
              key={item.id}
              value={item.id}
              label={item.label}
              image={item.image}
              hasSelected={!!data.style}
              isActive={data.style === item.id}
              onChange={(value) => handleChange("style", value)}
            />
          ))}
        </div>
      </CompanionFormStep>
    </CompanionForm>
  );
};
